import { Button, ButtonGroup } from '@mui/material'
import _ from 'lodash'
import moment from 'moment'
import { useContext, useState } from 'react'
import Plot from 'react-plotly.js'
import { ThemeContext } from '../theme-context'
import { Score } from '../utils/dataFormatting'
import { habitTypes } from './HabitsPanel'

type TimeScale = 'all time' | 'last 3 months' | 'this round'

export function getHabitTypeCountArray({ scores }: { scores: Score[] }) {
  const scoresGroupedByType = _.groupBy(scores, (s) => s.habitType)
  const countsGroupedByType = _.mapValues(
    scoresGroupedByType,
    (g) => g.filter((s) => s.points > 0).length
  )
  const typeCountArray = _.map(habitTypes, (habitType) => ({
    habitType,
    count: countsGroupedByType[habitType],
  }))
  return typeCountArray
}

export const ScoreCountChart = ({ scores }: { scores: Score[] }) => {
  const [selectedTimeScale, setTimeScale] = useState<TimeScale>('this round')
  const [isInDarkMode] = useContext(ThemeContext)

  const scoresWithinTimeScale = _.filter(
    scores,
    (s) =>
      selectedTimeScale === 'all time' ||
      (selectedTimeScale === 'last 3 months' &&
        s.day.isBetween(moment().subtract(3, 'months'), moment())) ||
      (selectedTimeScale === 'this round' && !!s.isCurrentRound)
  )

  const typeCountArray = getHabitTypeCountArray({
    scores: scoresWithinTimeScale,
  })

  const timeScaleOptions: TimeScale[] = [
    'all time',
    'last 3 months',
    'this round',
  ]

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <Plot
        data={[
          {
            x: habitTypes.map((h) => _.startCase(h)),
            y: typeCountArray.map((a) => a.count),
            type: 'bar',
          },
        ]}
        layout={{
          title: 'Number of times target was achieved 🎯',
          font: {
            size: 8,
            color: isInDarkMode ? 'white' : 'black',
          },
          width: 300,
          height: 300,
          margin: {
            l: 25,
            r: 10,
            b: 80,
            t: 30,
            pad: 10,
          },
          paper_bgcolor: 'rgba(0, 0, 0, 0)',
          plot_bgcolor: 'rgba(0, 0, 0, 0)',
          xaxis: { fixedrange: true },
          yaxis: { fixedrange: true, rangemode: 'tozero' },
          annotations:
            scoresWithinTimeScale.length === 0
              ? [
                  {
                    text: 'No data to display',
                    xref: 'paper',
                    yref: 'paper',
                    showarrow: false,
                    font: { size: 14 },
                  },
                ]
              : [],
        }}
        config={{ displayModeBar: false }}
      />
      <ButtonGroup variant="contained">
        {timeScaleOptions.map((timeScale) => (
          <Button
            key={timeScale}
            variant={timeScale === selectedTimeScale ? 'outlined' : 'contained'}
            onClick={() => setTimeScale(timeScale)}
          >
            {_.startCase(timeScale)}
          </Button>
        ))}
      </ButtonGroup>
    </div>
  )
}
